import React from 'react'
import PropTypes from 'prop-types'
import { Hidden, makeStyles } from '@material-ui/core'
import { useRouteMatch } from 'react-router-dom'
import Background from '../../../providers/BackgroundProvider/Background'
import Navbar from './Navbar'
import LayoutProvider from './contexts/LayoutProvider'
import MobileNavbarHeader from './MobileNavbar/Header'

const useStyles = makeStyles((theme) => ({
  container: {
    color: 'var(--dai-color-text)',
    display: 'flex',
    height: '100vh',
    position: 'relative'
  },
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflowY: 'auto',
    height: '100%'
  },
  mobileScrollRoot: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '100%'
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0 // Allow content to shrink below its minimum content size
  }
}))

function AssistantLayout ({ children }) {
  const { path } = useRouteMatch()
  const classes = useStyles()

  // Use useRouteMatch to check if we're on a thread route
  const threadMatch = useRouteMatch(`${path}/chat/:threadId`)
  const activeThreadId = threadMatch?.params?.threadId || null

  return (
    <LayoutProvider>
      <Background
        light='var(--dai-bg)'
        dark='var(--dai-bg)'
      >
        <Hidden smDown>
          <div className={classes.container}>
            <Navbar activeThreadId={activeThreadId} />
            <div className={classes.mainContent}>
              {children}
            </div>
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.mobileScrollRoot}>
            <div className={classes.mobileContainer}>
              <MobileNavbarHeader />
              <div className={classes.mainContent}>
                {children}
              </div>
            </div>
          </div>
        </Hidden>
      </Background>
    </LayoutProvider>
  )
}

AssistantLayout.propTypes = {
  children: PropTypes.node.isRequired
}

export default AssistantLayout
